export enum TAG_TYPE_SUN {
    segmentation = 'segmentation',
    playerTagsTriggers = 'player_tags_triggers'
}
